export default __webpack_public_path__ + "static/media/ioa.e31dab9e.jpg";